<template>
	<div id="app">
		<el-breadcrumb class="nav" separator="/" style="margin-bottom: 13px;">
			<el-breadcrumb-item>系统设置</el-breadcrumb-item>
			<el-breadcrumb-item>感情加温背景图</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="main">
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
			<el-form-item label="背景图:" prop="img_url">
				<el-upload class="avatar-uploader" :action="this.$http_host + '/Admin/Set/changeHeartBg'" :headers="headers" :show-file-list="false"
					:on-success="UploadSuccess"
					:before-upload="beforeUpload"
					:on-error="UploadError"
				>
				  <img v-if="ruleForm.img_url" :src="this.$http_host + ruleForm.img_url" class="avatar">
				  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
			</el-form-item>
			
			<el-form-item label="" prop="">
				<div style="color:red;">背景图尺寸：345x200, 点击图片修改上传</div>
			</el-form-item>
		</el-form>
		</div>
	</div>
</template>

<script>
	export default {
	    data() {
			return {
				
				ruleForm: {
					img_url: '/images/card-1.png',
					types:'',
					param:'',
					remarks: ''
				},
				rules: {
					img_url: [{required: true, message: '请上传图片', trigger: 'blur'}],
					types: [{required: true, message: '请选择跳转类型', trigger: 'blur'}],
					param: [{required: true, message: '请输入参数，不跳转输入#', trigger: 'blur'}],
					remarks: [{required: true, message: '请输入备注信息', trigger: 'blur'}]
				},
				headers:{
					Authorization:'',
				}
	      };
	    },
		created() {
			this.headers.Authorization = localStorage.getItem('access_token');
		},
	    methods: {
			beforeUpload(file){
			},
			UploadSuccess(res, file, fileList){
				if(res.code == 200)
				{
					this.ruleForm.img_url = res.data.url;
				}else{
					return this.$message({ message: res.msg, type: 'warning' });
				}
			},
			UploadError(){
				return this.$message({ message: '上传失败，请重试', type: 'warning' });
			},
			submitApi(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '保存中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post("/Set/changeHeartBg", this.ruleForm).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						_this.$message({
							 message: '添加成功~',
							 type: 'success',
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			submitForm(formName) {
				let _this = this;
				this.$refs[formName].validate((valid) => {
					if (valid) {
						_this.submitApi();
					} else {
						return _this.$message({
							 message: '提交失败',
							 type: 'warning',
						});
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
	    }
	  }
</script>

<style scoped>
	#app {
		padding: 20px;
	}
	.main {
		background-color: white;
		padding: 50px 0;
	}
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    min-width: 345px;
	    height: 200px;
	    line-height: 200px;
	    text-align: center;
		border:dashed 1px #dcdcdc;
	  }
	  .avatar {
	    min-width: 345px;
	    height: 200px;
	    display: block;
	  }
</style>